//@flow

import React, { Fragment, Component } from 'react';
import Rater from 'react-rater';

import '../../../../node_modules/react-rater/lib/react-rater.css';

type RatingAndPriceProps = {
  price: { currency: string, amount: number } | null,
  average_rating?: number | null,
  reviews?: { number_of_reviews: number, link: string } | null,
};

export default class RatingAndPrice extends Component<RatingAndPriceProps> {
  static defaultProps = {
    allowReviews: true,
    allowRatings: true,
  };

  render() {
    const { price, average_rating, reviews, allowReviews, allowRatings } = this.props;

    return (
      <Fragment>
        <div className="rating">
          {allowRatings && (
            <div className="star">
              <Rater total={5} rating={average_rating} interactive={false} />
            </div>
          )}
          {allowReviews && (
            <p className="reviews">
              {reviews ? reviews.number_of_reviews : 0} Review
              {reviews && reviews.number_of_reviews > 1 ? 's' : ''}
            </p>
          )}
        </div>

        {price && (
          <div className="price">
            <small>From</small>
            <p>
              {price.currency} {Math.ceil(price.amount).toLocaleString()}
            </p>
          </div>
        )}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Cards/Common/RatingAndPrice.jsx